import { Box } from "@chakra-ui/react";
import { RouteMeta } from "@/components";
import { FAQ, FAQ_LABEL, HOME_META } from "@/content";
import { DiscordCta, Footer, Nav, SkipLink } from "@/layout";
import { Applications, Claims, Cost, Faq, Feature, Hero, HowItWorks, PricingCta, Proof, Shift } from "@/sections";

export const HomePage = () => (
  <>
    <RouteMeta meta={HOME_META} />
    <SkipLink />
    <Nav />
    <Box as="main" id="main">
      <Box as="span" id="top" />
      <Hero />
      <Claims />
      <Feature />
      <HowItWorks />
      <Applications />
      <Shift />
      <Cost />
      <PricingCta />
      <Faq entries={FAQ} label={FAQ_LABEL} />
      <Proof />
      <DiscordCta />
    </Box>
    <Footer />
  </>
);
